import { ICatAge } from "libs/cat-calculations/src/lib/cat-calculations.types";
import dayjs from "dayjs";

export const NUMBER_OF_DAYS_IN_A_WEEK = 7;

export const DAYS_IN_YEAR = 365;

export const NUMBER_OF_MONTHS_IN_A_YEAR = 12;

export const DEFAULT_DATE_AS_VALUE_FORMAT = "YYYY-MM-DD";
export const DEFAULT_DATE_AS_DISPLAY_FORMAT = "dddd D MMMM";
export const DEFAULT_TIME = "HH:mm";
export const LOGGING_TIME = "HH:mm:ss";
export const SHORTHAND_DATE_AS_VALUE_FORMAT = "DD/MM/YYYY";

export const toWeeks = (days: number): number => days / NUMBER_OF_DAYS_IN_A_WEEK;
export const fromWeeks = (weeks: number): number => weeks * NUMBER_OF_DAYS_IN_A_WEEK;

export const getNow = () => dayjs();

export const getCatAgeFromDate = (date?: dayjs.ConfigType): ICatAge => {
  if (!date) {
    return { years: 0, months: 0, weeks: 0 };
  }
  const now = getNow();
  const pastDate = dayjs(date);

  const totalMonths = now.diff(pastDate, "month");

  const years = Math.floor(totalMonths / NUMBER_OF_MONTHS_IN_A_YEAR);
  const months = totalMonths % NUMBER_OF_MONTHS_IN_A_YEAR;

  const yearsAndMonths = dayjs(date).add(years, "year").add(months, "month");
  const weeks = now.diff(yearsAndMonths, "week");

  return { years, months, weeks };
};

export const formatDateString = (
  dateString: string,
  format: string | undefined = DEFAULT_DATE_AS_DISPLAY_FORMAT,
): string => dayjs(dateString).format(format);

export const getDateString = (
  date: Date | undefined,
  format: string | undefined = DEFAULT_DATE_AS_VALUE_FORMAT,
): string | undefined => {
  if (!date) { return; }
  return dayjs(date).format(format).toString();
};
